import { render, staticRenderFns } from "./OfferSiteCreateClient.vue?vue&type=template&id=6ca184ef&"
import script from "./OfferSiteCreateClient.vue?vue&type=script&lang=js&"
export * from "./OfferSiteCreateClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca184ef')) {
      api.createRecord('6ca184ef', component.options)
    } else {
      api.reload('6ca184ef', component.options)
    }
    module.hot.accept("./OfferSiteCreateClient.vue?vue&type=template&id=6ca184ef&", function () {
      api.rerender('6ca184ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/OfferSiteCreateClient.vue"
export default component.exports